import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from '@mc/i18n'

const NoResultsFound = ({ query }) => {
  const { t } = useTranslation('@mc/algolia-search')

  return (
    <div className='mc-p-4 mc-text--center'>
      {t('searchResults.noResultsFoundForQuery', { query })}
    </div>
  )
}

NoResultsFound.propTypes = {
  query: PropTypes.string,
}

export default NoResultsFound
